import(/* webpackMode: "eager" */ "/vercel/path0/my-project/src/app/enterprise/page.tsx");
